export default "__VITE_ASSET__D0Jrh$Xg__"